import Projects from '../../api/Projects'
import { Link } from 'react-router-dom'
import React, { useContext } from 'react';
import { LanguageContext } from '../../index';

const ProjectSection = (props) => {

    const { language } = useContext(LanguageContext);
    const isPolish = language === 'pl';
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const content = {
        pl: {
            title: <>Sprawdź nasze <span className="thin">realizacje</span></>,
            subtitle: "Zobacz, jak deska podłogowa zmienia wnętrza",
            area: "m2"
        },
        en: {
            title: <>Check our <span className="thin">projects</span></>,
            subtitle: "See how floorboards transform interiors",
            area: "sqm"
        }
    };

    const t = content[language] || content.pl;

    return (
        <section className="apartment-section text-center mb-155">
            <div className="container">
                <div className="section-title mb-75">
                    <h2>{t.title}</h2>
                    <p>{t.subtitle}</p>
                </div>
                <div className="apartment-carousel">
                    <div className="row">
                    {Projects.slice(0, 3).map((project, i) => (
                        <div className="col col-lg-4 col-md-6 col-12" key={i}>
                            <div className="apartment-item">
                                <div className="apartment-img">
                                    <img src={project.pImg} alt="Apartment" />
                                </div>
                                <div className="apartment-content">
                                    <img src={project.ssIcon} alt="Icon" />
                                    <h3><Link onClick={ClickHandler} to={`/project-single/${project.slug}`}>{isPolish ? project.pTitle : project.pTitleEn}</Link></h3>
                                    <span> {project.width} {t.area}</span>
                                    <p>{isPolish ? project.des : project.desEn} </p>
                                </div>
                            </div>
                        </div>
                    ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ProjectSection;